export default "__VITE_ASSET__CSXxGmpE__"